import { baseUrl } from "../../../boot/index";
import axios from "axios";

// delete SolarBrand 
export const deleteSolarBrand = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/finance/app/v1/delete-solar-brand/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// add SolarBrand
export const addSolarBrand = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/create-solar-brand`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log({ error })
      throw error
    }
  }


// update SolarBrand
export const updateSolarBrand = async (id, data) => {
  console.log({ data })
 
  console.log("hello ", id)
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/finance/app/v1/update-solar-brand/${id}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}

// total count Attendance
export const countSolarBrand = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getcount-solar-brand`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}